import React from "react";
import {teamService} from "../../_services/team.service";
import TeamsList from "./TeamsList";
import {connect} from "react-redux";
import {teamConstants} from "../../_constants/team.constants";
import {teamActions} from "../../_actions/team.actions";
import {CreateTeamForm} from "./CreateTeamForm";
import { toast } from 'react-toastify';

class ManageTeams extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            teams: null
        }
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch(teamActions.getAll());
    }

    _handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const { dispatch } = this.props;
            dispatch(teamActions.uploadLogo(file));
            this.fileInputRef.current.value = "";

            toast("The team logo uploaded successfully.");
        }
    }

    _handleButtonClick = () => {
        this.fileInputRef.current.click();
    }

    render() {
        const { teams, loading, uploadingLogo, logoUrl } = this.props;
        const justCreatedTeam = teams && teams.some(t => t.justCreated);

        return <section className="manage-teams">
            <CreateTeamForm
                    onSave={this._createTeam}
                    defaultForm={justCreatedTeam}
                    uploadingLogo={uploadingLogo}
                    logoUrl={logoUrl}
                    onFileChange={this._handleFileChange} 
                    onUploadButtonClick={this._handleButtonClick}
                    fileInputRef={this.fileInputRef}
            />
            {
                loading || teams === null
                ? 'Loading...'
                : <TeamsList teams={teams} onRemoveRequest={this._removeTeam}></TeamsList> }
            </section>;
    }

    _createTeam = (form) => {
        const { dispatch } = this.props;
        dispatch(teamActions.create(form));

        toast("The team created successfully.");
    }

    _removeTeam = (teamId) => {
        if (!confirm('Are you sure you want to delete this team?')) {
            return;
        }

        const { dispatch } = this.props;
        dispatch(teamActions.remove(teamId));

        toast("The team deleted successfully.");
    }
}

export default connect(state => {
    const teams = state.teams?.teams ?? null;
    
    return ({
        loading: state.teams?.loading,
        teams: teams,
        uploadingLogo: state.teams?.uploadingLogo,
        logoUrl: state.teams?.logoUrl
    });
})(ManageTeams);
